module.exports = __webpack_public_path__ + "assets/instagram_logo_white.30fa0886f8b6840a53f5deb91f9722f5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/instagram_logo_white.png
 ** module id = 181
 ** module chunks = 0
 **/